<mat-card id="card" fxLayout="column" class="mainContentBody">
    <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
        <h2>Gestione Software</h2>
        <div fxLayout="column" class="responsive-mat-form">
          <mat-form-field>
            <input matInput [(ngModel)]="parameters.filter" placeholder="Filter"/>
          </mat-form-field>
        </div>
        <mat-card-actions>
          <button mat-raised-button id="search-button" (click)="list()" name="Search" color="primary">Search</button>
          <button mat-raised-button id="new-button" [routerLink]="['/software/detail/0']">New</button>
        </mat-card-actions>
        <br/>
        <div *ngIf="parameters.showList" fxLayout="column">
          <table mat-table fxFlex matTableExporter #exporter="matTableExporter" [hiddenColumns]="hiddenColumns()"
            matSort (matSortChange)="setSort($event)" matSortDisableClear 
            [dataSource]="parameters.dataSource">
        
            <!-- Id Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
              <td mat-cell *matCellDef="let application"> {{ application.id }} </td>
            </ng-container>
            
            <!-- nome Column -->
            <ng-container matColumnDef="nome">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > nome </th>
              <td mat-cell *matCellDef="let application"> {{ application.nome }} </td>
            </ng-container>
            
            <!-- mac Column -->
            <ng-container matColumnDef="tipologia">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > tipologia </th>
              <td mat-cell *matCellDef="let application"> {{ application.tipologia }} </td>
            </ng-container>
            
            <!-- descrizione Column -->
            <ng-container matColumnDef="descrizione">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > descrizione </th>
              <td mat-cell *matCellDef="let application"> {{ application.descrizione }} </td>
            </ng-container>
            
            <!-- signInOutDescription Column -->
            <ng-container matColumnDef="signInOutDescription">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > signInOutDescription </th>
              <td mat-cell *matCellDef="let application"> {{ application.signInOutDescription }} </td>
            </ng-container>
            
            <!-- modalitaAccesso Column -->
            <ng-container matColumnDef="modalitaAccesso">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > modalitaAccesso </th>
              <td mat-cell *matCellDef="let application"> {{ application.modalitaAccesso }} </td>
            </ng-container>
            
            <!-- utilizzatori Column -->
            <ng-container matColumnDef="utilizzatori">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > utilizzatori </th>
              <td mat-cell *matCellDef="let application"> {{ application.utilizzatori}} </td>
            </ng-container>
            
            <!-- trasferimentoDati Column -->
            <ng-container matColumnDef="trasferimentoDati">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > trasferimentoDati </th>
              <td mat-cell *matCellDef="let application"> {{ application.trasferimentoDati }} </td>
            </ng-container>

            <ng-container matColumnDef="detail">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let application">
                  <button mat-mini-fab color="primary" [routerLink]="['/software/detail/', application.id]"><mat-icon>search</mat-icon></button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <mat-card-actions>
                <button mat-raised-button (click)="exporter.exportTable('xlsx', {fileName:'softwares'})">Excel</button>
                <button fxHide fxShow.gt-md mat-raised-button (click)="exporter.exportTable('csv', {fileName:'softwares'})">Csv</button>
                <button fxHide fxShow.gt-md mat-raised-button (click)="exporter.exportTable('json', {fileName:'softwares'})">Json</button>
            </mat-card-actions>
            <mat-paginator [pageSize]="parameters.pageSize" [pageIndex]="parameters.pageNumber" [length]="parameters.length" [pageSizeOptions]="[10,50,100]" (page)="setPaginator($event)"></mat-paginator>
          </div>
      </div>
    </mat-card-content>
  </mat-card>